import React from 'react'

import type { Product } from '@ztechapps/common.contract'
import type { BusyButtonProps } from '@ztechapps/webui.button'
import { BusyButton } from '@ztechapps/webui.button'
import { useTrackEvent } from '@ztechapps/webui.telemetry'

import { useAddToCart } from '../../hooks/useAddToCart'

export type AddToCartButtonProps = { product: Pick<Product, '_id' | 'code'> } & BusyButtonProps

export const AddToCartButton = ({ product, ...rest }: AddToCartButtonProps) => {
  const trackEvent = useTrackEvent()
  const { addToCart, loading, icon, text } = useAddToCart({ quantity: 1, product: { _id: product._id } })

  const onClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    trackEvent('Add To Cart', { product_code: product.code })
    await addToCart(e)
  }

  return <BusyButton text={text} icon={icon} onClick={onClick} disabled={loading} {...rest} />
}
